@if (model.prefix) {
<p [innerHTML]="model.prefix" class="prefix-label-input"></p>
}
<mat-form-field
  [appearance]="model.getAdditional('appearance', 'outline')"
  [color]="model.getAdditional('color', 'primary')"
  [formGroup]="group"
  [hideRequiredMarker]="model.getAdditional('hideRequiredMarker', false)"
  [ngClass]="getClass('grid', 'control')"
  [class]="model.id"
>
  @if (model.label) {
  <ng-container ngProjectAs="mat-label">
    @if (model.getAdditional('showLabelOnInit', true) ? true : isFocus) {
    <mat-label [innerHTML]="model.label"></mat-label>
    }
  </ng-container>
  } @if (checkPrefixId(model.id)) {
  <div matPrefix class="prefix-contact-input">
    <span class="flag:{{ activeCountry$ | async }}"></span
    ><span class="flag-contact-number">{{ mobilePrefix$ | async }}</span>
  </div>
  }

  <!-- Applied conditional rendering to separate masked and non-masked inputs to avoid value accessor conflict. -->
  <!-- TODO: Refactor to a single input binding once ngx-mask integration can be simplified.  -->
  @if (model.mask) {
  <ng-container>
    <input
      matInput
      [mask]="{ mask: model.mask || false, showMask: model.mask && !model.placeholder }"
      [attr.accept]="model.accept"
      [attr.max]="model.max"
      [attr.min]="model.min"
      [attr.multiple]="model.multiple"
      [attr.step]="model.step"
      [autocomplete]="model.autoComplete"
      [autofocus]="model.autoFocus"
      [errorStateMatcher]="model.getAdditional('errorStateMatcher', errorStateMatcher)"
      [formControlName]="model.id"
      [id]="id"
      [maxlength]="model.maxLength"
      [matAutocomplete]="matAutocomplete"
      [minlength]="model.minLength"
      [name]="model.name"
      [ngClass]="getClass('element', 'control')"
      [pattern]="model.pattern"
      [placeholder]="removeHTMLTags(model.placeholder)"
      [readonly]="model.readOnly"
      [required]="model.required"
      [spellcheck]="model.spellCheck"
      [tabindex]="model.tabIndex"
      [type]="model.inputType"
      (blur)="onBlur($event); checkInput(model.value)"
      (change)="onChange($event); checkInput(model.value)"
      (focus)="onFocus($event); ifFocus($event)"
    />
  </ng-container>
  } @else {
  <ng-container>
    <input
      matInput
      [attr.accept]="model.accept"
      [attr.max]="model.max"
      [attr.min]="model.min"
      [attr.multiple]="model.multiple"
      [attr.step]="model.step"
      [autocomplete]="model.autoComplete"
      [autofocus]="model.autoFocus"
      [errorStateMatcher]="model.getAdditional('errorStateMatcher', errorStateMatcher)"
      [formControlName]="model.id"
      [id]="id"
      [maxlength]="model.maxLength"
      [matAutocomplete]="matAutocomplete"
      [minlength]="model.minLength"
      [name]="model.name"
      [ngClass]="getClass('element', 'control')"
      [pattern]="model.pattern"
      [placeholder]="removeHTMLTags(model.placeholder)"
      [readonly]="model.readOnly"
      [required]="model.required"
      [spellcheck]="model.spellCheck"
      [tabindex]="model.tabIndex"
      [type]="model.inputType"
      (blur)="onBlur($event); checkInput(model.value)"
      (change)="onChange($event); checkInput(model.value)"
      (focus)="onFocus($event); ifFocus($event)"
    />
  </ng-container>
  } @if (model.suffix) {
  <span matSuffix [innerHTML]="model.suffix"></span>
  } @if (model.hint !== null) {
  <mat-hint align="start" [innerHTML]="model.hint"></mat-hint>
  } @if (showCharacterHint) {
  <mat-hint align="end">{{ characterHint }}</mat-hint>
  } @for (message of errorMessages; track message) {
  <mat-error>{{ message }}</mat-error>
  }
</mat-form-field>

<mat-autocomplete
  #matAutocomplete="matAutocomplete"
  [autoActiveFirstOption]="model.getAdditional('autoActiveFirstOption', AUTOCOMPLETE_OPTIONS['autoActiveFirstOption'])"
  [disableRipple]="model.getAdditional('disableRipple', (RIPPLE_OPTIONS && RIPPLE_OPTIONS['disabled']) || false)"
  [displayWith]="model.getAdditional('displayWith', null)"
  (optionSelected)="onChange($event)"
>
  @if (model.getAdditional('matAutocomplete', null) === null) { @for (option of model.list$ | async; track option) {
  <mat-option [value]="option">{{ option }}</mat-option>
  } } @else { @for (option of model.list$ | async; track option) {
  <mat-option [value]="option">
    {{ option[model.getAdditional('optionLabel', 'label')] }}
  </mat-option>
  } }
</mat-autocomplete>
